module.exports = __webpack_public_path__ + "img/desktop-elbow-1_76x98.a4042c5e.png";